import React from 'react';
import classNames from 'classnames';

import styles from '../SummaryTool.module.scss';

function StandardPageSummary({ page }) {
  const questionCount = page.elements?.length ?? 0;

  return (
    <div className={classNames(styles['page-summary'], styles['standard'])}>
      <section>
        <h5 className={styles['capability-name']}>
          {page.title?.trim() || (
            <span className="text-muted font-italic">Untitled page</span>
          )}
        </h5>
        <div className="text-info">
          {questionCount} {questionCount === 1 ? 'question' : 'questions'}
        </div>
      </section>
    </div>
  );
}

export default StandardPageSummary;
